import React from "react";
import cn from "classnames";
import styles from "./Theme.module.sass";
import useDarkMode from "use-dark-mode";
import Icon from "../Icon";
import { useUser } from "../../context";
import sidebar from "../../i11/Sidebar";

const Theme = ({ className, visibleSidebar }) => {
	const darkMode = useDarkMode(false);
	const { locale } = useUser();

	return (
		<label
			className={cn(className, styles.theme, { [styles.wide]: visibleSidebar })}
		>
			<input
				className={styles.input}
				checked={darkMode.value}
				onChange={darkMode.toggle}
				type="checkbox"
			/>
			<span className={styles.inner}>
				<span className={styles.box}>
					<Icon name="sun" size="24" />
					{sidebar[locale].light}
				</span>
				<span className={styles.box}>
					<Icon name="moon" size="24" />
					{sidebar[locale].dark}
				</span>
			</span>
		</label>
	);
};

export default Theme;
